var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-full-a", attrs: { id: "category" } }, [
    _c(
      "div",
      {
        staticClass: "admin-content-area",
        attrs: { id: "page-content-wrapper" }
      },
      [
        _c("div", { staticClass: "container-fluid xyz" }, [
          _c("div", { staticClass: "page-header-top-container" }, [
            _c("div", { staticClass: "page-name" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.question) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "pull-right btn btn-info deleteMedia mr-1 ",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.backButton()
                  }
                }
              },
              [_vm._v("Back")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "admin-page-content" }, [
            _c("div", { staticClass: "forms-container" }, [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _c("div", { staticClass: "col-12 paddingleft0" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _vm._v(" Comment : " + _vm._s(_vm.comment))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { title: "Delete Comment", id: "delete" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.deleteComment()
                    }
                  }
                },
                [_vm._v("Delete")]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("app-backend-footer")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cdf6d0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cdf6d0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/forum/ViewQuestionOfForumComment.vue
// module id = null
// module chunks = 